import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class PaymentOptionService {
  static async update(id, data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PAYMENTOPTION_UPDATE(
          $id: String!
          $data: PaymentOptionInput!
          $manage: ManageInput!
        ) {
          paymentOptionUpdate(id: $id, data: $data, manage: $manage) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        manage,
      },
    });

    return response.data.paymentOptionUpdate;
  }

  static async destroyAll(ids, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PAYMENTOPTION_DESTROY($ids: [String!]!  $manage: ManageInput!) {
          paymentOptionDestroy(ids: $ids,  manage: $manage) 
        }
      `,

      variables: {
        ids,
        manage,
      },
    });

    return response.data.paymentOptionDestroy;
  }

  static async create(data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PAYMENTOPTION_CREATE($data: PaymentOptionInput!  $manage: ManageInput!) {
          paymentOptionCreate(data: $data,   manage: $manage) {
            id
          }
        }
      `,

      variables: {
        data,
        manage,
      },
    });

    return response.data.paymentOptionCreate;
  }

  static async import(values, importHash, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PAYMENTOPTION_IMPORT(
          $data: PaymentOptionInput!
          $importHash: String!
          $manage: ManageInput!
        ) {
          paymentOptionImport(data: $data, importHash: $importHash, manage: $manage)
        }
      `,

      variables: {
        data: values,
        importHash,
        manage,
      },
    });

    return response.data.paymentOptionImport;
  }

  static async find(id, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query PAYMENTOPTION_FIND($id: String!  $manage: ManageInput!) {
          paymentOptionFind(id: $id,  manage: $manage) {
            id
            type
            status
            numberOfPayments
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        manage,
      },
    });

    return response.data.paymentOptionFind;
  }

  static async list(filter, orderBy, limit, offset, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query PAYMENTOPTION_LIST(
          $filter: PaymentOptionFilterInput
          $orderBy: PaymentOptionOrderByEnum
          $limit: Int
          $offset: Int
          $manage: ManageInput!
        ) {
          paymentOptionList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
            manage: $manage
          ) {
            count
            rows {
              id
              type
              status
              numberOfPayments
              createdAt
              updatedAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
        manage,
      },
    });

    return response.data.paymentOptionList;
  }

  static async listAutocomplete(query, limit, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query PAYMENTOPTION_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $manage: ManageInput!
        ) {
          paymentOptionAutocomplete(query: $query, limit: $limit,  manage: $manage) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
        manage
      },
    });

    return response.data.paymentOptionAutocomplete;
  }
}
